import {BarSortOrder} from 'entities/chart';
import {notRenderedKeysArray} from '@/views/storyboard/charts/utils/SortLegendKeys';
import type {BarChartData} from './BarChartWrapper';

function getBarChartValueKey(distinctKeys: string[]): string {
    const dataKeys = distinctKeys.filter((key) => !notRenderedKeysArray.includes(key));
    return dataKeys[0] ?? 'docCount';
}

function isOtherBarRow(row: BarChartData): boolean {
    const record = row as Record<string, unknown>;
    return record.key === 'Other' || record.labelShort === 'Other';
}

function getBarRowValue(row: BarChartData, valueKey: string): number {
    return Number((row as Record<string, unknown>)[valueKey]) || 0;
}

export function sortBarChartData(
    data: BarChartData[],
    distinctKeys: string[],
    barSortOrder: BarSortOrder,
): BarChartData[] {
    const valueKey = getBarChartValueKey(distinctKeys);
    const otherRows = data.filter(isOtherBarRow);
    const sortableRows = data.filter((row) => !isOtherBarRow(row));
    const direction = barSortOrder === BarSortOrder.HighToLow ? -1 : 1;

    sortableRows.sort((left, right) => (
        (getBarRowValue(left, valueKey) - getBarRowValue(right, valueKey)) * direction
    ));

    return [...sortableRows, ...otherRows];
}
